import { SYSTEM_BET_TYPE } from './bettingEnums';
import { SystemBetTypeExtended } from './bettingInterfaces';

export const CASHOUT_OFFER_REJECTED_VALUE_UPDATE = 'Cashout offer has changed';
export const AMOUNT_INCREASE_DECREASE_STEP = 1;
export const TB_CAROUSEL_MAX_EVENT_NAME_LENGTH = 60;

export const ACCA_SYSTEM_BET_ID = -1;

export const accaSystemBet: SystemBetTypeExtended = {
  id: ACCA_SYSTEM_BET_ID,
  numberOfTickets: 1,
  name: SYSTEM_BET_TYPE.ACCA,
  description: '',
  combinationsOfOutcomes: [1],
};

export const MAX_BOOSTED_BETS_ENVELOPES_DESKTOP = 10;

export const MAX_BOOSTS_DISPLAY_IN_SUMMARY = 3;

export const SYSTEM_BET_SUMMARY_TITLE_DISPLAY_DELAY_MS = 1500;
export const SYSTEM_BET_SUMMARY_ORIGINAL_PAYOUT_DISPLAY_DELAY_MS = 1750;
export const SYSTEM_BET_SUMMARY_KWIFFED_PAYOUT_DISPLAY_DELAY_MS = 2000;

export const SYSTEM_BET_DELAY_FOR_ROCKET_LAUNCH = 2.5;

export const ROCKET_LAUNCH_ANIMATION_TIME = 2;
